export function functionWithCondition<Fn extends (...args: any[]) => any>(
	condition: () => boolean,
	functionTrue: Fn,
	functionFalse: Fn,
): Fn {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const fnWithCondition = ((...args) =>
		condition() ? functionTrue(...args) : functionFalse(...args)) as Fn;

	return fnWithCondition;
}
